// The download function takes a CSV string and the filename as parameters
export const exportCSV = function (data: string, fileName?: string) {
  // A data: URI would silently truncate the file at the first "#" in the CSV
  // (encodeURI leaves it unescaped, so the browser drops the rest as a URL
  // fragment) and is length-capped. The BOM makes Excel read the file as UTF-8.
  const blob = new Blob(["\ufeff" + data], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.setAttribute("href", url);
  link.setAttribute("download", (fileName ?? "data") + ".csv");
  document.body.appendChild(link); // Required for FF

  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
